<template>
  <div class="overview">
    <div class="layer">
      <div class="common width">
        <div class="commonhbox">
          <el-input style="width:200px;" placeholder="请输入内容" v-model="organization" clearable></el-input>
          <el-button
            style="margin-left:30px;background: #75867c;"
            :loading="loading"
            type="primary"
            icon="el-icon-search"
            @click="goOrgHome(organization)"
          >搜索</el-button>
        </div>
        <div class="commonhbox" v-loading="loading1">
          <el-row>
            <el-col :span="5" class="c-left">
              <h3>机构信息</h3>

              <div style="font-size:24px;font-weight:bold;">{{orgData.name}}</div>
              <img :src="orgData.logo" alt v-if="orgData.logo" />
            </el-col>
            <el-col :span="19" class="c-center">
              <ul class="elseinttext" v-if="orgData.introduction">
                <li class="elseinttext-item">{{orgData.introduction.trim() }}</li>
              </ul>
              <span v-else>暂无简介</span>
            </el-col>
          </el-row>
        </div>
        <div class="commonhbox">
          <el-button
            type="info"
            :plain="isActive !== item.value"
            style="margin-bottom: 30px;background: #7faaca;"
            v-for="(item,index) in tabs"
            :key="index"
            :class="{active : ( isActive === item.value ? true : false )}"
            @click="isActive = item.value;currentComp = item.comp;"
          >{{item.name}}</el-button>

          <keep-alive>
            <org1 :is="currentComp" :allData="allData" :orgData="orgData"></org1>
          </keep-alive>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import org1 from './Orgs/org1'
import org2 from './Orgs/org2'
import org3 from './Orgs/org3'
import org4 from './Orgs/org4'
import { getRes, getOrg } from '@/api/organization'

export default {
  name: 'Overview',
  components: {
    org1,
    org2,
    org3,
    org4
  },
  data () {
    return {
      organization: this.$route.query.organization, // 带入机构
      orgData: {}, // 机构信息
      /* tab切换 */
      currentComp: 'org1',
      isActive: '1',
      tabs: [
        {
          name: '成果概览',
          value: '1',
          comp: 'org1'
        },
        {
          name: '成果分析',
          value: '2',
          comp: 'org2'
        },
        {
          name: '相关学者',
          value: '3',
          comp: 'org3'
        },
        {
          name: '学术趋势',
          value: '4',
          comp: 'org4'
        }
      ], //
      allData: {},

      /* loading */
      loading: false,
      loading1: false
    }
  },
  methods: {
    // 获取成果概览等数据
    searchOrg () {
      this.loading = true
      const data =
        this.orgData.nameAlt === null
          ? {
            name: [this.orgData.name],
            code: ['J', 'I', 'P'],
            year: [2010, 2018]
          }
          : {
            name: [
              this.orgData.name,
              this.orgData.nameAlt,
              this.orgData.shortNameAlt
            ],
            code: ['J', 'I', 'P'],
            year: [2010, 2018]
          }
      getRes(data)
        .then(res => {
          this.loading = false
          this.allData = res.data
          this.allData['name'] = this.orgData.name
        })
        .catch(err => {
          console.log(err)
        })
    },

    // 搜索学校
    goOrgHome (organization) {
      if (!organization) {
        this.$message('请输入搜索内容!')
        return
      }
      this.$router.push({
        path: '/OrgHome',
        query: { organization: organization }
      })
    }
  },
  mounted () {
    this.loading1 = true
    let data = {
      name: this.organization
    }
    // 获取学校信息
    getOrg(data)
      .then(res => {
        this.loading1 = false
        this.orgData = res.data.data.result[0]
        this.searchOrg()
      })
      .catch(err => {
        console.log(err)
      })
  }
}
</script>

<style lang="scss">
.overview {
  background: #f2f2f2;
  .common {
    .commonhbox {
      background: #fff;
      border: 1px #ccc solid;
      padding: 30px;
      margin-top: 15px;
      .el-button--info.is-plain {
        color: #000;
      }
      .el-button--info.is-plain :hover {
        color: #fff;
      }
    }
    .commonhbox {
      .c-left {
        float: left;
        img {
          width: 95px;
          height: 95px;
        }
        h3 {
          margin-bottom: 20px;
        }
      }
      .c-center {
        ::-webkit-scrollbar {
          width: 6px;
          background-color: #f2f2f2;
        }
        ::-webkit-scrollbar-thumb {
          background-color: #dedede;
        }
        float: left;
        .elseinttext {
          text-indent: 2em;
          font-size: 14px;
          overflow: auto;
          height: 200px;
          text-indent: 2em;
          .elseinttext-item {
            border: none;
            margin-bottom: 0;
            height: 200px;
          }
        }
      }
      .c-right {
        img {
          float: right;
        }
      }
    }
    .comBth {
      display: inline-block;
      box-sizing: border-box;
      width: 100px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      color: #409eff;
      background: #ecf5ff;
      border-color: #b3d8ff;
      border: 1px solid #b3d8ff;
      font-size: 14px;
      border-radius: 4px;
      &:hover {
        background: #3a8ee6;
        border-color: #3a8ee6;
        color: #fff;
        outline: 0;
        transition: 0.5s;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/organization/Overview.vue